import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthFullScreenLockScreen() {
	return <AuthShell variant="full-screen"><AuthForm variant="full-screen" mode="lock-screen" /></AuthShell>;
}

export default AuthFullScreenLockScreen;
